import Cookies from "js-cookie";

const ACCESS_TOKEN = "token";

export const tokenService = {
  setToken: (
    token: string
  ) => {
    Cookies.set(ACCESS_TOKEN, token);
  },

  getToken: () => {
    return Cookies.get(ACCESS_TOKEN);
  },

  clearToken: () => {
    Cookies.remove(ACCESS_TOKEN);
  },
};
